import React from 'react';

import { useThemeDefinition } from '@tanium/react-theme-definition';

import { AxisStroke } from '../Axis/themeDefinitions';
import { Svg } from '../Svg';

export const OverlayBottomAxisLine = ({
  xMin,
  xMax,
  width,
  plotBottom,
}: {
  xMin: number;
  xMax: number;
  width: number;
  plotBottom: number;
}): JSX.Element => {
  const axisStrokeColor = useThemeDefinition(AxisStroke);
  return (
    <Svg width={width} height={2} style={{ position: 'absolute', top: plotBottom - 1 }}>
      <line x1={xMin} x2={xMax} y1={1} y2={1} stroke={axisStrokeColor} />
    </Svg>
  );
};
